import { BaseEntityWithChildIds, EntityTypes } from '@email-editor/ui'
import React, { useState } from 'react'
import { useDrag } from 'react-dnd'
import { useDispatch } from 'react-redux'
import { twMerge } from 'tailwind-merge'
import { emailSelectors, useTypedSelector } from '../../../store'
import * as emailActions from '../../../store/email/actions'
import { EntityControll } from './EntityControll'

type EntityMoverProps = {
  type: keyof typeof EntityTypes
  id: string
  backgroundColor: string
  parentId: string
  position: number
}

const EntityMover = ({ type, id, backgroundColor, parentId, position }: EntityMoverProps) => {
  const dispatch = useDispatch()
  const parentEntity = useTypedSelector(state =>
    emailSelectors.getEntityById(state.email, parentId),
  ) as BaseEntityWithChildIds
  const [upDownVisible, setUpDownVisible] = useState(false)
  const [, dragRef] = useDrag({
    item: { type, id },
    type,
  })

  const possibleMoveDown = position + 1 < parentEntity.childIds.length
  const possibleMoveUp = position > 0

  function showUpDownButtons(event: React.SyntheticEvent) {
    event.stopPropagation()
    setUpDownVisible(true)
  }

  function hideUpDownButtons(event: React.SyntheticEvent) {
    event.stopPropagation()
    setUpDownVisible(false)
  }

  function moveUp(event: React.SyntheticEvent) {
    event.stopPropagation()
    dispatch(emailActions.moveEntity(id, parentId, position - 1))
  }

  function moveDown(event: React.SyntheticEvent) {
    event.stopPropagation()
    dispatch(emailActions.moveEntity(id, parentId, position + 1))
  }

  return (
    <>
      <EntityControll
        ref={dragRef}
        className="absolute left-2 top-1/2 -translate-y-1/2 cursor-move "
        style={{ backgroundColor }}
        onMouseOver={showUpDownButtons}
      >
        <span className="fas fa-arrows-alt" />
      </EntityControll>

      <div
        className={twMerge(
          'absolute left-11 top-1/2 z-10 flex h-6 -translate-y-1/2 items-center justify-between gap-3 transition-all',
          upDownVisible ? 'scale-x-100 opacity-100' : 'scale-x-0 opacity-0',
        )}
        onMouseLeave={hideUpDownButtons}
      >
        {possibleMoveUp && (
          <EntityControll className="cursor-pointer" style={{ backgroundColor }} onClick={moveUp}>
            <i className="fas fa-chevron-up" />
          </EntityControll>
        )}

        {possibleMoveDown && (
          <EntityControll className="cursor-pointer" style={{ backgroundColor }} onClick={moveDown}>
            <i className="fas fa-chevron-down" />
          </EntityControll>
        )}
      </div>
    </>
  )
}

export default EntityMover
